import { jsx as _jsx } from "react/jsx-runtime";
import { useRef, useLayoutEffect } from 'react';
import { Menu } from '@sas/nova-commons/components/Menu';
import { BirdActionMenuState } from '../../store/birdActionMenu/BirdActionMenuState';
import { useI18n } from '../../locale/I18nContext';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
export const BirdActionMenuBase = ({ actions, state }) => {
    const title = useI18n(state.title || '');
    const localize = useI18n();
    const items = state.items.map((item) => ({
        text: localize(item.text),
        icon: item.icon,
    }));
    const sections = [{ title: title || undefined, items }];
    const x = state.position.x;
    const y = state.position.y;
    const isOpen = !!state.items.length;
    const lastFocusedElement = useRef(null);
    useLayoutEffect(() => {
        if (isOpen) {
            // Action menu is opening; remember which element was focused last
            lastFocusedElement.current = document.activeElement;
        }
    }, [isOpen]);
    function restoreFocus() {
        var _a;
        (_a = lastFocusedElement.current) === null || _a === void 0 ? void 0 : _a.focus();
        lastFocusedElement.current = null;
    }
    return (_jsx(Menu, { isOpen: isOpen, position: { x, y }, sections: sections, onItemSelected: (indexPairs) => {
            const [[, index], ...rest] = indexPairs;
            if (rest.length > 0) {
                return; // Nesting does not yet exist for this menu
            }
            // Restore focus immediately so:
            //  1. HiddenSections get the correct value for document.activeElement
            //  2. Focus does not get stolen from the new section during a page link
            restoreFocus();
            actions.select(state.context, index);
        }, onDismiss: () => {
            restoreFocus();
            actions.close();
        } }));
};
export const BirdActionMenu = connect((state) => ({ state: state.ui.birdActionMenu }), (dispatch) => ({ actions: bindActionCreators(BirdActionMenuState.actions, dispatch) }))(BirdActionMenuBase);
